import { Link } from 'react-router';
import sunfishLogo from '~/assets/img/sunfish-logo.svg';
import { Button } from '@sunfish/ui';

interface NotFoundContentProps {
	logoUrl?: string | null;
	backLink: string;
	backLinkText: string;
}

export function NotFoundContent({ logoUrl, backLink, backLinkText }: NotFoundContentProps) {
	const isExternal = backLink.startsWith('http');

	return (
		<div className="flex min-h-screen flex-col items-center justify-center bg-sidebar px-4">
			<div className="mb-8">
				<img
					src={logoUrl || sunfishLogo}
					alt="Event Logo"
					className={logoUrl ? 'max-h-16 w-auto' : 'opacity-80'}
					width={logoUrl ? undefined : 280}
					height={logoUrl ? undefined : 42}
				/>
			</div>
			<div className="text-center">
				<h1 className="text-8xl font-bold text-muted-foreground/30">404</h1>
				<h2 className="mt-4 text-2xl font-semibold text-foreground">Page Not Found</h2>
				<p className="mt-2 text-muted-foreground">The page you're looking for doesn't exist or has been moved.</p>
				<div className="mt-8">
					{isExternal ? (
						<Button variant="brand" size="lg" asChild>
							<a href={backLink}>{backLinkText}</a>
						</Button>
					) : (
						<Button variant="brand" size="lg" asChild>
							<Link to={backLink}>{backLinkText}</Link>
						</Button>
					)}
				</div>
			</div>
		</div>
	);
}
